import type { FeedbackClientError } from "../api/types";

/** Dernières erreurs JavaScript de la page (registre F39) : jointes au contexte d'une anomalie signalée, pour
 *  l'équipe. Dix au plus, les plus récentes ; message et source bornés, jamais de pile complète (elle peut citer des
 *  données du dossier). Les erreurs des rendus attrapées par `ErrorBoundary` y sont ajoutées par `recordError`. */

const MAX = 10;
const errors: FeedbackClientError[] = [];

function bounded(text: unknown, limit: number): string {
  return String(text ?? "")
    .replace(/\s+/g, " ")
    .trim()
    .slice(0, limit);
}

/** Inscrit une erreur (la plus ancienne sort au-delà de dix). */
export function recordError(message: unknown, source?: unknown): void {
  const text = bounded(message instanceof Error ? `${message.name}: ${message.message}` : message, 300);
  if (!text) return;
  const entry: FeedbackClientError = { message: text, at: new Date().toISOString() };
  const where = bounded(source, 200);
  if (where) entry.source = where;
  errors.push(entry);
  if (errors.length > MAX) errors.splice(0, errors.length - MAX);
}

/** Erreurs gardées, de la plus ancienne à la plus récente (copie). */
export function recentErrors(): FeedbackClientError[] {
  return errors.map((e) => ({ ...e }));
}

export function clearErrorsForTests(): void {
  errors.length = 0;
}

/** Écoute des erreurs non rattrapées et des promesses rejetées sans suite, une fois au démarrage. */
export function installErrorLog(target: Window | undefined = typeof window === "undefined" ? undefined : window): void {
  if (!target) return;
  target.addEventListener("error", (event) => {
    const e = event as ErrorEvent;
    const where = e.filename ? `${e.filename.split("/").pop()}:${e.lineno ?? 0}` : undefined;
    recordError(e.error ?? e.message, where);
  });
  target.addEventListener("unhandledrejection", (event) => {
    recordError((event as PromiseRejectionEvent).reason, "unhandledrejection");
  });
}
